import { GET_ALL_PROGRAMS, GET_PROGRAM_BY_ID, UPDATE_PROGRAM_BY_ID } from "../types";
import { call, takeLatest } from "redux-saga/effects";
import { GetAllProgramsApi, GetProgramByIdApi, UpdateProgramByIdApi } from "../api/programs-api";

export function* getAllProgramsWorker(action: any): any {
  try {
    const { type } = action.data || {};
    const res: any = yield call(GetAllProgramsApi, type);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAllProgramsWatcher() {
  yield takeLatest(GET_ALL_PROGRAMS, getAllProgramsWorker);
}

export function* getProgramByIdWorker(action: any): any {
  try {
    const { prog_id } = action.data || {};
    const res: any = yield call(GetProgramByIdApi, prog_id);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateProgramByIdWorker(action: any): any {
  try {
    const res: any = yield call(UpdateProgramByIdApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* programDetailsWatcher() {
  yield takeLatest(GET_PROGRAM_BY_ID, getProgramByIdWorker);
}

export function* updateProgramWatcher() {
  yield takeLatest(UPDATE_PROGRAM_BY_ID, updateProgramByIdWorker);
}
